import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-educational',
  templateUrl: './educational.component.html'
})
export class EducationalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
